import { Button, DropdownMenu } from 'components/atoms';
import { useComponentVisible } from 'hooks';
import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';
import { PiDownload } from 'react-icons/pi';
import { IButtonProps } from 'types/components/button/button.interface';
import { IJustifyPositionProps } from 'types/components/components.interface';

interface IAudioDownloadButtonProps
  extends IButtonProps,
    IJustifyPositionProps {
  withText?: boolean;
  mp3Url?: string;
  wavUrl?: string;
  flacUrl?: string;
}

const AudioDownloadButton = ({
  withText = true,
  justifyPosition = 'center',
  mp3Url,
  wavUrl,
  flacUrl,
  ...props
}: IAudioDownloadButtonProps) => {
  const { t } = useTranslation();

  const { ref, isComponentVisible, handleComponentVisible } =
    useComponentVisible<HTMLDivElement>(false);

  const onDownloadAudio = () => {
    handleComponentVisible();
    toast.success(t('toast-message.audio-downloaded-successfully'));
  };

  return (
    <Button
      onClick={handleComponentVisible}
      onlyIcon={!withText}
      outsideChildren={
        <DropdownMenu
          ref={ref}
          visible={isComponentVisible}
          justifyPosition={justifyPosition}
          style={{ padding: '0' }}>
          {/* <div className='flex flex-col w-full'> */}
          <div>
            {mp3Url && (
              <a href={mp3Url} onClick={onDownloadAudio}>
                <Button isClear fullWidth>
                  <Button.Text text={`.mp3 `} />
                </Button>
              </a>
            )}
            {wavUrl && (
              <a href={wavUrl} onClick={onDownloadAudio}>
                <Button isClear fullWidth>
                  <Button.Text text={`.wav`} />
                </Button>
              </a>
            )}
            {flacUrl && (
              <a href={flacUrl} onClick={onDownloadAudio}>
                <Button isClear fullWidth>
                  <Button.Text text={`.flac`} />
                </Button>
              </a>
            )}
          </div>
        </DropdownMenu>
      }
      {...props}>
      {!withText && (
        <Button.Description description={t('button.download')} />
      )}
      {withText && <Button.Text text={t('button.download')} />}
      <Button.Icon icon={<PiDownload />} />
    </Button>
  );
};

export default AudioDownloadButton;
